<template>
  <div>
  <floating-menu :event-id="eventId"></floating-menu>
  <b-row>
    <b-col cols="12">
      <event-booth-table />
    </b-col>
  </b-row>
  <b-row class="mt-1">
    <b-col cols="12">
      <event-booth-participant-table :participants="participants" :booths="booths" />
    </b-col>
  </b-row>
  <b-row class="mt-1">
    <b-col cols="12">
      <event-booth-participant-complete-list :participants="participants" :booths="booths" />
    </b-col>
  </b-row>
</div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import EventBoothTable from './EventBoothTable.vue'
import EventBoothParticipantTable from './EventBoothParticipantTable.vue'
import EventBoothParticipantCompleteList from './EventBoothParticipantCompleteList.vue'
import router from '@/router'
import FloatingMenu from './FloatingMenu.vue'

export default {
  components: {
    BRow,
    BCol,
    FloatingMenu,
    EventBoothTable,
    EventBoothParticipantTable,
    EventBoothParticipantCompleteList
  },
  data() {
    return {
      eventId: router.currentRoute.params.id,
      participants: [],
      booths: []
    }
  },
  methods: {
    getParticipants() {
      // Fetch participants logic here
      this.$http.get('/admin/v1/event_booths/' + this.eventId + '/participants')
        .then((response) => {
          this.participants = response.data.data.participants
          this.booths = response.data.data.booths

          // console.log(this.participants)
          // console.log(this.booths)
        })
    },
  },
  created() {
    this.getParticipants()
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>